import { Router } from '@angular/router'
import { EDITOR_MAXIMIZED_QUERY_PARAM, EditorSettingsService } from '../../editor-settings.service'
import { OpenMeetingEvent } from './citation-plugin'

/** Point the meeting view at a cited transcript passage, leaving the maximized editor so it can be seen. */
export function openCitedMeeting(router: Router, editorSettingsService: EditorSettingsService, event: OpenMeetingEvent): void {
  // Clear editor.max in the same navigate as the highlight params; a separate setIsEditorMaximized(false)
  // would race with this call and Angular Router would cancel one of them.
  editorSettingsService.updateMaximizedStateOnly(false)
  void router.navigate([], {
    queryParams: {
      sentenceId: event.startSentenceId,
      endSentenceId: event.endSentenceId,
      highlight: true,
      [EDITOR_MAXIMIZED_QUERY_PARAM]: null,
    },
    queryParamsHandling: 'merge',
  })
}
